import { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { getCategories } from 'loot-core/src/client/actions';
import { type State } from 'loot-core/src/client/state-types';

import { useLocalPref } from './useLocalPref';

export function useCategories(includeOffBudget = true) {
  const dispatch = useDispatch();
  const [budgetId] = useLocalPref('id');
  const categoriesLoaded = useSelector(
    (state: State) => state.queries.categoriesLoaded,
  );
  const categoriesData = useSelector(state => state.queries.categories);

  useEffect(() => {
    if (!categoriesLoaded && budgetId) {
      dispatch(getCategories());
    }
  }, [categoriesLoaded]);

  const filteredCategories = useMemo(() => {
    if (includeOffBudget) {
      return categoriesData;
    }

    const catGroups = structuredClone(categoriesData.grouped);
    const catList = categoriesData.list.filter(c => !c.is_offbudget);
    catGroups.forEach(
      g => (g.categories = g.categories.filter(c => !c.is_offbudget)),
    );
    return {
      grouped: catGroups,
      list: catList,
    };
  }, [categoriesData]);

  return filteredCategories;
}
